/**
 * ProjectTemplateVersionEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { ProjectTemplateVersionEntity } from "../ProjectTemplateVersionEntity";
declare global {
    interface EntityTypeMap {
        ProjectTemplateVersion: ProjectTemplateVersionEntity;
    }
}
export abstract class ProjectTemplateVersionGeneratedEntity extends BaseEntity {
    public abstract projectTemplateVersionId: string;
    public abstract projectTemplateId: string;
    public abstract version: string;
    public abstract project: ProjectEntity;
}
